import type { IncidentCategory } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

interface Props extends ChakraV3.TagRootProps {
  category: IncidentCategory;
}

export const IncidentCategoryTag = (props: Props) => {
  const { category, ...rest } = props;
  const { color, name } = category;

  return (
    <ChakraV3.Tag colorPalette={color} {...rest}>
      {name}
    </ChakraV3.Tag>
  );
};
